const B_1 = [
    {
        title: '中标候选人公示',
        path: '/bidding/projectflow/dingbiao/zbhxr-gs/list'
    }
]
export default {
    path: 'zbhxrgs',
    component: () => import(/*webpackChunkName: 'bidding-zbhxrgs'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import(/*webpackChunkName: 'bidding-zbhxrgs'*/ '@views/bidding/views/project-flow/ding/zbhxr-gs/list'),
            meta: {
                title: '中标候选人公示列表',
                bread: B_1
            },
        },{
            path:"form",
            component: () => import(/*webpackChunkName: 'bidding-zbhxrgs'*/ '@views/bidding/views/project-flow/ding/zbhxr-gs/form'),
            meta: {
                title: '添加中标候选人公示',
                bread: [
                    ...B_1,
                    {
                        title: '添加中标候选人公示',
                        path: '/bidding/projectflow/dingbiao/zbhxr-gs/form'
                    },
                ]
            },
        },{
            path:"bggs",
            component: () => import('@views/bidding/views/project-flow/ding/zbhxr-gs/form-bggs'),
            meta: {
                title: '变更公示',
                bread: [
                    ...B_1,
                    {
                        title: '变更公示',
                        path: '/bidding/projectflow/dingbiao/zbhxr-gs/bggs'
                    },
                ]
            },
        },{
            path:"detail",
            component: () => import('@views/bidding/views/project-flow/ding/zbhxr-gs/detail'),
            meta: {
                title: '中标候选人公示详情',
                bread: [
                    ...B_1,
                    {
                        title: '中标候选人公示详情',
                        path: '/bidding/projectflow/dingbiao/zbhxr-gs/detail'
                    },
                ]
            },
        },
    ]
}